import Hero from '../components/home/Hero';
import About from '../components/home/About';
import FeaturedProjects from '../components/home/FeaturedProjects';
import LatestBlog from '../components/home/LatestBlog';

export default function Home() {
  return (
    <div>
      <Hero />
      <About />
      <FeaturedProjects />
      <LatestBlog />

      {/* Contact CTA */}
      <section className="py-24 bg-gradient-to-br from-primary/20 via-secondary/20 to-cta/20">
        <div className="container-custom text-center">
          <h2 className="text-5xl md:text-6xl font-heading font-bold mb-6">
            让我们连接
          </h2>
          <p className="text-xl text-gray-700 mb-8 max-w-2xl mx-auto">
            无论你有项目想法、技术问题，还是只是想打个招呼，我都欢迎你的来信！
          </p>
          <a
            href="mailto:zzy885277374@gmail.com"
            className="btn-neubrutal bg-cta text-white px-8 py-4 text-lg inline-block"
          >
            联系我
          </a>
        </div>
      </section>
    </div>
  );
}
